import Header from "components/Layout/Header";
import styles from "./styles.scss";
import MainTitle from "components/Title/MainTitle";
import SubTitle from "components/Title/SubTitle";
import CheckingBox from "components/CheckingBox";
import { useCallback, useEffect, useState } from "react";
import Button from "components/Button";
import * as _ from "lodash";
import tableCommonStyles from "components/Table/styles.scss";
import { Check } from "components/SVG";
import Select from "react-select";
import Modal01 from "components/Modal/Modal01";
import { useDispatch, useSelector } from "react-redux";
import { beneficiariesInfo } from "module/contractModule";

const selectStyles = {
    control: (provided) => ({
        ...provided,
        border: "0",
        fontSize: "13px",
        boxShadow: "none",
        input: {
            textIndent: "-99999999em",
        },
    }),
    valueContainer: (provided) => ({
        ...provided,
        padding: 0,
    }),
    singleValue: (provided) => ({
        ...provided,
        marginLeft: 0,
    }),
    indicatorSeparator: (provided) => ({
        ...provided,
        width: 0,
    }),
    option: (provided, state) => ({
        ...provided,
        backgroundColor: state.isFocused ? "rgba(0, 0, 0, 0.08)" : undefined,
        color: "rgba(0, 0, 0, 0.87)",
        height: "48px",
        lineHeight: "48px",
        padding: "0 0 0 0px",
        fontSize: "14px",
    }),
    menu: (provided, state) => ({
        ...provided,
        position: "absolute",
        top: "33px",
        borderRadius: "4px",
        boxShadow: "0 8px 10px 0 rgba(0, 0, 0, 0.14)",
    }),
    placeholder: (provided) => ({
        ...provided,
        fontSize: "10px",
        display: "flex",
        alignItems: "center",
        height: "100%",
        color: "#cccccc",
    }),
};

const ConfirmBeneficiary = (props) => {
    const dispatch = useDispatch();
    const { data } = useSelector(state => state.contract);
    
    const [regNoErr, setRegNoErr] = useState(false);
    const [fillErr, setFillErr] = useState(false);
    const [emptyErr, setEmptyErr] = useState(false);
    const [modalOpen1, setModalOpen1] = useState(false);
    const [checkList, setCheckList] = useState([]);
    const [btnDisabled, setBtnDisabled] = useState(true);
    // 지배자 테이블 활성화 여부
    const [tableDisabled, setTableDisabled] = useState(true);
    const initialState = [
        {H_NAME: "", H_LBIRTH: "", H_COUNTRY: "", H_COUNTRYC: "", H_CONTYPE1: false, H_CONTYPE2: false, H_CONTYPE3: false, H_CONTYPE4: false},
        {H_NAME: "", H_LBIRTH: "", H_COUNTRY: "", H_COUNTRYC: "", H_CONTYPE1: false, H_CONTYPE2: false, H_CONTYPE3: false, H_CONTYPE4: false},
        {H_NAME: "", H_LBIRTH: "", H_COUNTRY: "", H_COUNTRYC: "", H_CONTYPE1: false, H_CONTYPE2: false, H_CONTYPE3: false, H_CONTYPE4: false},
        {H_NAME: "", H_LBIRTH: "", H_COUNTRY: "", H_COUNTRYC: "", H_CONTYPE1: false, H_CONTYPE2: false, H_CONTYPE3: false, H_CONTYPE4: false},
        {H_NAME: "", H_LBIRTH: "", H_COUNTRY: "", H_COUNTRYC: "", H_CONTYPE1: false, H_CONTYPE2: false, H_CONTYPE3: false, H_CONTYPE4: false},
    ]
    const [inputValue, setInputValue] = useState(initialState);

    const descArr = [
        {
            isTitle: false, isRadio: true, field: "check1",
            script:
                <>
                    <div>
                        단독으로 또는 다른 주주 등과의 합의‧계약 등에 따라 해당 법인의 주주등의 의결권 과반수를 행사할 수 있는 자가 있습니까?
                    </div>
                </>
        },
        {
            isTitle: false, isRadio: true, field: "check2",
            script:
                <>
                    <div>
                        단독으로 또는 다른 주주등과의 합의‧계약 등에 따라 해당 법인의 대표자 업무집행사원 또는 임원 등의 과반수를 선임한 자가 있습니까?
                    </div>
                </>
        },
        {
            isTitle: false, isRadio: true, field: "check3",
            script:
                <>
                    <div>
                        해당 법인과의 계약 또는 정관에 따라 임원의 구성이나 자금‧재산의 운용등에 대하여 사실상의 영향력을 행사할 수 있는 자가 있습니까?
                    </div>
                </>
        },
        {
            isTitle: false, isRadio: true, field: "check4",
            script:
                <>
                    <div>
                        그 밖에 이에 준하여 법인의 주요 경영사항에 사실상의 영향력을 행사할 수 있다고 인정되는 자가 있습니까?
                    </div>
                </>
        }
    ]

    const national = [
        { value: "KR", label: "한국" },
        { value: "AD", label: "안도라" },
        { value: "AE", label: "아랍에미리트" },
        { value: "AF", label: "아프가니스탄" },
        { value: "AG", label: "앤티가 바부다" },
        { value: "AI", label: "앵귈라" },
        { value: "AL", label: "알바니아" },
        { value: "AM", label: "아르메니아" },
        { value: "AN", label: "Dutch Antilles" },
        { value: "AO", label: "앙골라" },
        { value: "AQ", label: "남극 대륙" },
        { value: "AR", label: "아르헨티나" },
        { value: "AS", label: "미국령 사모아" },
        { value: "AT", label: "오스트리아" },
        { value: "AU", label: "오스트레일리아" },
        { value: "AW", label: "아루바" },
        { value: "AZ", label: "아제르바이잔" },
        { value: "BA", label: "Bosnia-Herz." },
        { value: "BB", label: "바베이도스" },
        { value: "BD", label: "방글라데시" },
        { value: "BE", label: "벨기에" },
        { value: "BF", label: "부르키나파소" },
        { value: "BG", label: "불가리아" },
        { value: "BH", label: "바레인" },
        { value: "BI", label: "부룬디" },
        { value: "BJ", label: "베냉" },
        { value: "BL", label: "파랑" },
        { value: "BM", label: "버뮤다" },
        { value: "BN", label: "브루나이" },
        { value: "BO", label: "볼리비아" },
        { value: "BR", label: "브라질" },
        { value: "BS", label: "바하마" },
        { value: "BT", label: "부탄" },
        { value: "BV", label: "부베이 섬" },
        { value: "BW", label: "보츠와나" },
        { value: "BY", label: "벨로루시" },
        { value: "BZ", label: "벨리즈" },
        { value: "CA", label: "캐나다" },
        { value: "CC", label: "코코넛 섬" },
        { value: "CD", label: "콩고민주공화국" },
        { value: "CF", label: "CAR" },
        { value: "CG", label: "콩고" },
        { value: "CH", label: "스위스" },
        { value: "CI", label: "코트디부아르" },
        { value: "CK", label: "쿡 제도" },
        { value: "CL", label: "칠레" },
        { value: "CM", label: "카메룬" },
        { value: "CN", label: "중국" },
        { value: "CO", label: "콜롬비아" },
        { value: "CR", label: "코스타리카" },
        { value: "CS", label: "Serbia/Monten." },
        { value: "CU", label: "쿠바" },
        { value: "CV", label: "카보베르데" },
        { value: "CX", label: "크리스마스 섬" },
        { value: "CY", label: "키프로스" },
        { value: "CZ", label: "체코" },
        { value: "DE", label: "독일" },
        { value: "DJ", label: "지부티" },
        { value: "DK", label: "덴마크" },
        { value: "DM", label: "도미니카" },
        { value: "DO", label: "도미니카 공화국" },
        { value: "DZ", label: "알제리" },
        { value: "EC", label: "에콰도르" },
        { value: "EE", label: "에스토니아" },
        { value: "EG", label: "이집트" },
        { value: "EH", label: "서사하라" },
        { value: "ER", label: "에리트레아" },
        { value: "ES", label: "스페인" },
        { value: "ET", label: "에티오피아" },
        { value: "EU", label: "유럽연합" },
        { value: "FI", label: "핀란드" },
        { value: "FJ", label: "피지" },
        { value: "FK", label: "포클랜드 제도" },
        { value: "FM", label: "미크로네시아" },
        { value: "FO", label: "페로 제도" },
        { value: "FR", label: "프랑스" },
        { value: "GA", label: "가봉" },
        { value: "GB", label: "영국" },
        { value: "GD", label: "그레나다" },
        { value: "GE", label: "그루지야" },
        { value: "GF", label: "프랑스령 기아나" },
        { value: "GH", label: "가나" },
        { value: "GI", label: "지브롤터" },
        { value: "GL", label: "그린란드" },
        { value: "GM", label: "감비아" },
        { value: "GN", label: "기니" },
        { value: "GP", label: "과들루프" },
        { value: "GQ", label: "적도 기니" },
        { value: "GR", label: "그리스" },
        { value: "GS", label: "S. Sandwich Ins" },
        { value: "GT", label: "과테말라" },
        { value: "GU", label: "괌" },
        { value: "GW", label: "기니비사우" },
        { value: "GY", label: "가이아나" },
        { value: "HK", label: "홍콩" },
        { value: "HM", label: "Heard/McDon.Isl" },
        { value: "HN", label: "온두라스" },
        { value: "HR", label: "크로아티아" },
        { value: "HT", label: "아이티" },
        { value: "HU", label: "헝가리" },
        { value: "ID", label: "인도네시아" },
        { value: "IE", label: "아일랜드" },
        { value: "IL", label: "이스라엘" },
        { value: "IN", label: "인도" },
        { value: "IO", label: "Brit.Ind.Oc.Ter" },
        { value: "IQ", label: "이라크" },
        { value: "IR", label: "이란" },
        { value: "IS", label: "아이슬란드" },
        { value: "IT", label: "이탈리아" },
        { value: "JM", label: "자메이카" },
        { value: "JO", label: "요르단" },
        { value: "JP", label: "일본" },
        { value: "KE", label: "케냐" },
        { value: "KG", label: "키르기스스탄" },
        { value: "KH", label: "캄보디아" },
        { value: "KI", label: "키리바시" },
        { value: "KM", label: "코모로" },
        { value: "KN", label: "St Kitts&Nevis" },
        { value: "KP", label: "북한" },
        { value: "KW", label: "쿠웨이트" },
        { value: "KY", label: "케이맨 제도" },
        { value: "KZ", label: "카자흐스탄" },
        { value: "LA", label: "라오스" },
        { value: "LB", label: "레바논" },
        { value: "LC", label: "세인트 루시아" },
        { value: "LI", label: "리히텐슈타인" },
        { value: "LK", label: "스리랑카" },
        { value: "LR", label: "라이베리아" },
        { value: "LS", label: "레소토" },
        { value: "LT", label: "리투아니아" },
        { value: "LU", label: "룩셈부르크" },
        { value: "LV", label: "라트비아" },
        { value: "LY", label: "리비아" },
        { value: "MA", label: "모로코" },
        { value: "MC", label: "모나코" },
        { value: "MD", label: "몰도바" },
        { value: "MG", label: "마다가스카르" },
        { value: "MH", label: "마셜 제도" },
        { value: "MK", label: "마케도니아" },
        { value: "ML", label: "말리" },
        { value: "MM", label: "미얀마" },
        { value: "MN", label: "몽골" },
        { value: "MO", label: "마카오" },
        { value: "MP", label: "북마리아나 제도" },
        { value: "MQ", label: "마르티니크" },
        { value: "MR", label: "마우레타니아" },
        { value: "MS", label: "몬트세라트" },
        { value: "MT", label: "몰타" },
        { value: "MU", label: "모리셔스" },
        { value: "MV", label: "몰디브" },
        { value: "MW", label: "말라위" },
        { value: "MX", label: "멕시코" },
        { value: "MY", label: "말레이시아" },
        { value: "MZ", label: "모잠비크" },
        { value: "NA", label: "나미비아" },
        { value: "NC", label: "뉴칼레도니아" },
        { value: "NE", label: "니제르" },
        { value: "NF", label: "노퍽 섬" },
        { value: "NG", label: "나이지리아" },
        { value: "NI", label: "니카라과" },
        { value: "NL", label: "네덜란드" },
        { value: "NO", label: "노르웨이" },
        { value: "NP", label: "네팔" },
        { value: "NR", label: "나우루" },
        { value: "NT", label: "NATO" },
        { value: "NU", label: "니우에" },
        { value: "NZ", label: "뉴질랜드" },
        { value: "OM", label: "오만" },
        { value: "OR", label: "주황색" },
        { value: "PA", label: "파나마" },
        { value: "PE", label: "페루" },
        { value: "PF", label: "Frenc.Polynesia" },
        { value: "PG", label: "파푸아뉴기니" },
        { value: "PH", label: "필리핀" },
        { value: "PK", label: "파키스탄" },
        { value: "PL", label: "폴란드" },
        { value: "PM", label: "St.Pier,Miquel." },
        { value: "PN", label: "핏케언 제도" },
        { value: "PR", label: "푸에르토리코" },
        { value: "PS", label: "팔레스타인" },
        { value: "PT", label: "포르투갈" },
        { value: "PW", label: "팔라우" },
        { value: "PY", label: "파라과이" },
        { value: "QA", label: "카타르" },
        { value: "RE", label: "리유니언 섬" },
        { value: "RO", label: "루마니아" },
        { value: "RU", label: "러시아" },
        { value: "RW", label: "르완다" },
        { value: "SA", label: "사우디아라비아" },
        { value: "SB", label: "솔로몬 제도" },
        { value: "SC", label: "세이셸" },
        { value: "SD", label: "수단" },
        { value: "SE", label: "스웨덴" },
        { value: "SG", label: "싱가포르" },
        { value: "SH", label: "세인트 헬레나" },
        { value: "SI", label: "슬로베니아" },
        { value: "SJ", label: "스발바르" },
        { value: "SK", label: "슬로바키아" },
        { value: "SL", label: "시에라리온" },
        { value: "SM", label: "산마리노" },
        { value: "SN", label: "세네갈" },
        { value: "SO", label: "소말리아" },
        { value: "SR", label: "수리남" },
        { value: "ST", label: "상투메 프린시페" },
        { value: "SV", label: "엘살바도르" },
        { value: "SY", label: "시리아" },
        { value: "SZ", label: "스와질란드" },
        { value: "TC", label: "Turksh Caicosin" },
        { value: "TD", label: "차드" },
        { value: "TF", label: "프랑스남쪽영역" },
        { value: "TG", label: "토고" },
        { value: "TH", label: "태국" },
        { value: "TJ", label: "타지키스탄" },
        { value: "TK", label: "토켈라우" },
        { value: "TL", label: "동티모르" },
        { value: "TM", label: "투르크메니스탄" },
        { value: "TN", label: "튀니지" },
        { value: "TO", label: "통가" },
        { value: "TP", label: "동티모르" },
        { value: "TR", label: "터키" },
        { value: "TT", label: "Trinidad,Tobago" },
        { value: "TV", label: "투발루" },
        { value: "TW", label: "대만" },
        { value: "TZ", label: "탄자니아" },
        { value: "UA", label: "우크라이나" },
        { value: "UG", label: "우간다" },
        { value: "UM", label: "소수 외부 제도" },
        { value: "UN", label: "UN" },
        { value: "US", label: "미국" },
        { value: "UY", label: "우르과이" },
        { value: "UZ", label: "우즈베키스탄" },
        { value: "VA", label: "바티칸" },
        { value: "VC", label: "세인트 빈센트" },
        { value: "VE", label: "베네수엘라" },
        { value: "VG", label: "Brit.Virgin Is." },
        { value: "VI", label: "Amer.Virgin Is." },
        { value: "VN", label: "베트남" },
        { value: "VU", label: "바누아투" },
        { value: "WF", label: "월리스 푸투나" },
        { value: "WS", label: "사모아" },
        { value: "YE", label: "예멘" },
        { value: "YT", label: "마요트" },
        { value: "ZA", label: "South Africa" },
        { value: "ZM", label: "잠비아" },
        { value: "ZW", label: "짐바브웨" },
    ];

    const checkArr = [
        {value: "H_CONTYPE1", title: 1, isDisabled: false},
        {value: "H_CONTYPE2", title: 2, isDisabled: false},
        {value: "H_CONTYPE3", title: 3, isDisabled: false},
        {value: "H_CONTYPE4", title: 4, isDisabled: false},
    ]

    useEffect(() => {
        window.addEventListener("beforeunload", function(e) {
            e.preventDefault();
            e.returnValue = "변경사항은 저장되지 않습니다";
        });
        if (!data) {
            props.history.push("/auth/contractNum");
        };
    }, [])

    const validateData = useCallback(() => {
        const activeInputRows = inputValue.filter((row) => 
                Object.values(row).some(value => (typeof value === "string" && value.trim() !== "") || (value === true))
        );
        const isAllFilled = activeInputRows.length > 0 && activeInputRows.every(row => {
            const isTextField = [row.H_NAME, row.H_LBIRTH, row.H_COUNTRY].every(val => typeof val === "string" && val.trim() !== "");
            const isTypeSelected = row.H_CONTYPE1 || row.H_CONTYPE2 || row.H_CONTYPE3 || row.H_CONTYPE4;
            return isTextField && isTypeSelected;
        });
        const isCheckLBIRTH = activeInputRows.every(row =>
            /^[0-9]{8}$|^[0-9]{10}$/.test(row.H_LBIRTH)
        );
        return { activeInputRows, isAllFilled, isCheckLBIRTH };
    }, [inputValue]);

    useEffect(() => {
        if (checkList.length !== 0) {
            setTableDisabled(false);
            setBtnDisabled(true);
        } else {
            setTableDisabled(true);
            setBtnDisabled(false);
            setInputValue(initialState)
        }
    }, [checkList])

    useEffect(() => {
        const { isAllFilled, isCheckLBIRTH } = validateData();
        if (checkList.length !== 0) {
            setBtnDisabled(!(isAllFilled && isCheckLBIRTH));
        } else {
            setBtnDisabled(false);
        }
    }, [validateData, checkList]);

    const handleCheckBeneficial = (idx) => {
        const beneficialNumber =  "H_CONTYPE" + (idx + 1);
        if (checkList.includes(beneficialNumber)) {
            setCheckList(checkList.filter(e => e !== beneficialNumber).sort((a,b) => a-b));
            // 체크된 상태에서 지배형태 해제 시, 체크된 상태 해제
            setInputValue(prev => {
                return prev.map((row) => ({...row, [beneficialNumber]: false}))
            })
        } else {
            setCheckList([...checkList, beneficialNumber].sort((a,b) => a-b))
        }
    }

    const handleChangeInputValue = (e, index) => {
        const {name, value} = e.target;
        setInputValue(prev => 
            prev.map((e, i) => 
                i === index ? {...e, [name]: value} : e
            )
        );
    }

    const handleChangeSelectValue = (e, index) => {
        setInputValue(prev => 
            prev.map((item, i) => 
                i === index ? {...item, H_COUNTRY: e.label, H_COUNTRYC: e.value} : item
            )
        );
    }

    const handleChangeCheckValue = (index, obj, isDisabled) => {
        if (isDisabled) return;
        setInputValue(prev => 
            prev.map((item, i) => {
                return i === index ? {...item, [obj.value]: !item[obj.value]} : item;
            })
        )
    }

    const handleClickConfirm = async () => {
        const { activeInputRows, isAllFilled, isCheckLBIRTH } = validateData();
        if (checkList.length !== 0) {
            if (activeInputRows.length === 0) return setEmptyErr(true);
            if (!isAllFilled) return setFillErr(true);
            if (!isCheckLBIRTH) return setRegNoErr(true);
        }

        const formatCheckList = checkList.map(data => data.replace("CONTYPE", "TYPE")); // H_CONTYPE1 => H_TYPE1 키값 변경
        const hasType = (type) => formatCheckList.includes(type);

        const payload = {
            H_TYPE1_Y: hasType('H_TYPE1'), H_TYPE1_N: !hasType('H_TYPE1'),
            H_TYPE2_Y: hasType('H_TYPE2'), H_TYPE2_N: !hasType('H_TYPE2'),
            H_TYPE3_Y: hasType('H_TYPE3'), H_TYPE3_N: !hasType('H_TYPE3'),
            H_TYPE4_Y: hasType('H_TYPE4'), H_TYPE4_N: !hasType('H_TYPE4'),
            beneficiaryList: activeInputRows,
        }
        await dispatch(beneficiariesInfo.post.request(payload));
        props.history.push("/cms/apply");
    };

    return (
        <>
            <Header onClick={() => props.history.push("/")} />
            <div className={styles.contentBoardWrap}>
                <div className={styles.contentBoard}>
                    <div className={styles.innerWrap}>
                        <MainTitle mainTitle="법인 사실상 지배자 확인">
                            <p>
                                본 체크리스트는 개정된 「테러자금금지법」에 근거하여 테러 관련자뿐 아니라 테러관련자가 직간접적으로 소유·지배하는
                                법인도 금융거래 및 재산권 처분이 제한됨에 따라 법인의 사실상 지배자를 확인하기 위하여 필수적으로 작성이 필요한
                                양식임을 알려드립니다. (테러자금금지법 제4조 및 동법 시행령에 따라 금융회사의 필수 확인사항)
                            </p>
                        </MainTitle>

                        <div className={styles.contBox}>
                            <div className={styles.termsWrap}>
                                <SubTitle title="법인 사실상 지배자 존재 여부 확인" isSpecial descYn="Y" styles={{ borderBottom: "1px solid #cccccc", marginBottom: "16px" }}>
                                    (*사실상 지배자: 주식소유와 무관하게 법인의 주요 경영사항에 대하여 사실상의 영향력을 행사하는 경우로 아래 유형에 해당하는 자)
                                </SubTitle>
                                {descArr.map((item, key) => {
                                    return (
                                        <>
                                            <span className={styles.checkTitle}>지배형태 {key + 1}</span>
                                            <CheckingBox
                                                idx={key}
                                                key={key}
                                                isTitle={item.isTitle}
                                                isRadio={item.isRadio}
                                                script={item.script}
                                                handleReqItem={handleCheckBeneficial}
                                                checked={checkList.includes(item)}
                                            />
                                        </>
                                    )
                                })}
                            </div>
                        </div>
                        {!tableDisabled && (
                            <div className="styles.contBox">
                                <div className={styles.termsWrap}>
                                    <SubTitle title="법인 사실상 지배자 정보 입력" isSpecial descYn="Y" styles={{ borderBottom: "1px solid #cccccc", marginBottom: "16px" }}>
                                        사실상 지배자 기재 기준: 상기 사실상 지배자 판단 기준에 해당사항이 있는 자 5명까지 기재
                                    </SubTitle>
                                    <div className={tableCommonStyles.tblWrap}>
                                        <table className={tableCommonStyles.tbl03}>
                                            <thead>
                                                <tr>
                                                    <td>항목</td>
                                                    <td style={{width:"20%"}}>성명/상호명</td>
                                                    <td style={{width:"20%"}}>생년월일(사업자번호)</td>
                                                    <td style={{width:"20%"}}>국적(본점소재지)</td>
                                                    <td style={{width:"20%"}}>지배형태(1~4중 택)</td>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {inputValue.map((row, index) => (
                                                    <tr key={index}>
                                                        <td>
                                                            지배자{index + 1}
                                                        </td>
                                                        <td style={{width:"20%"}}>
                                                            <input type="text" name="H_NAME" onChange={(e)=>handleChangeInputValue(e, index)}/>
                                                        </td>
                                                        <td style={{width:"20%"}}>
                                                            <input type="text" name="H_LBIRTH" onChange={(e)=>handleChangeInputValue(e, index)}/>
                                                        </td>
                                                        <td style={{width:"20%"}}>
                                                            <Select
                                                                styles={selectStyles}
                                                                options={national}
                                                                isSearchable={false}
                                                                name="H_COUNTRY"
                                                                placeholder="국적을 선택해주세요."
                                                                onChange={(e)=>handleChangeSelectValue(e, index)}
                                                            />
                                                        </td>
                                                        <td style={{width:"20%"}} >
                                                            <div className={styles.checkContainer}>
                                                                {checkArr.map((check, key) => {
                                                                    const isTargetDisabled = !checkList.includes(check.value);
                                                                    return (
                                                                        <div key={key} className={styles.checkItem} onClick={(e) => handleChangeCheckValue(index, check, isTargetDisabled)}>
                                                                            <Check isDisabled={isTargetDisabled} checked={row[check.value]}/>
                                                                            <span>{check.title}</span>
                                                                        </div>
                                                                    )
                                                                })}
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                        <div>
                                            <span className={styles.tableDesc}>
                                                (예시)생년월일 입력 시 : YYYYMMDD / (예시)사업자번호 입력 시 : 0000000000
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                        <Button text={"확인"} style={{ width: "100%" }} disabled={btnDisabled}
                            onClick={handleClickConfirm}/>
                    </div>
                </div>
            </div>
            <Modal01 open={regNoErr} close={() => setRegNoErr(false)} header="인증 실패">
                8자리의 생년월일 또는<br/>
                10자리의 사업자번호를 입력해주세요.
            </Modal01>
            <Modal01 open={fillErr} close={() => setFillErr(false)} header="인증 실패">
                입력 중인 지배자의<br/>
                모든 정보를 입력해 주세요.
            </Modal01>
            <Modal01 open={emptyErr} close={() => setEmptyErr(false)} header="인증 실패">
                지배자 정보를 입력해주세요.
            </Modal01>
            <Modal01 open={modalOpen1} close={() => setModalOpen1(false)} header="안내">
                다음 단계로 넘어가기 위해<br />
                모든 항목에 동의해주세요.
            </Modal01>
        </>
    )
}

export default ConfirmBeneficiary;